<template>
	<slot>
		<el-button slot="control" @click="dialogFormProductVisible">商品选取</el-button>
	</slot>
	<el-dialog title="商品选取" v-model="visible" @open="handleOpen">
		<el-form :model="form1" style="margin-top: -25px;" size="small" @submit.native.prevent>
			<el-row :gutter="20">
				<el-col :span="14">
					<el-form-item prop="keywords">
						<div style="display: flex;">
							<div>
								<el-input v-model="form1.keywords" placeholder="请输入商品名或者版号" :clearable="true" size="small" @keyup.enter.native="search()">
								</el-input>
							</div>
							<div>
								<el-button icon="el-icon-search" @click="search()"></el-button>
							</div>
						</div>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<el-table v-loading="loading" ref="multipleTable" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
			<el-table-column :reserve-selection="true" align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column label="名称" prop="product_name">
				<template v-slot="scope">
					<div style="display: flex;">
						<el-image v-if="scope.row.get_product_img_suo" class="goods-image" :src="this.getImgPrefix()+scope.row.get_product_img_suo.image_url"
						 fit="contain" lazy>
						</el-image>
						<div style="margin-left: 30px;">
							<div :title="scope.row.product_name" class="name">{{scope.row.product_name}}</div>
							<p class="model"><span style="color: #909399;">商品版号：</span>{{scope.row.product_model}}</p>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="状态" prop="product_status" align="center">
				<template v-slot="scope">
					<span>{{scope.row.product_status==1?'上架':'下架'}}</span>
				</template>
			</el-table-column>

		</el-table>
		<el-pagination layout="total,prev,pager,next" :current-page='currentPage' :total="total" :page-size="pageSize"
		 @size-change="handleSizeChange" @current-change='handleCurrentChange' background>
		</el-pagination>
		<div slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'cs-product-select',
		emits: ['confirm', 'check-list'],
		props: {
			checkList: {
				type: Array,
				default: function() {

					return [];
				}
			},
			dataType: {
				type: String,
				default: ''
			
			},
			
		},
		data() {
			return {
				total:0,
				currentPage:1,
				pageSize:10,
				visible: false,
				form1: {
					keywords: '',
				},
				loading:false,
				currentPages: this.currentPage,
				pageSizes: this.pageSize,
				multipleSelection: [],
				tableData: [],
			}
		},
		methods: {
			getGoodsAdminList(){
				this.loading=true;
				this.httpPost({
					url:'/admin/common/getProductData',
					data:{p:this.currentPages,dataType:this.dataType}
				}).then((res)=>{
					this.tableData  = res.data.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
					this.loading=false;
				})
			},
			search(){
				this.form1.dataType = this.dataType
				this.httpPost({
					url:'/admin/common/getProductData',
					data:this.form1
				}).then((res)=>{
					this.tableData= res.data.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
					
				})
			},
			handleOpen() {
				this.$nextTick(() => {
					this.$refs.multipleTable.clearSelection();
					this.checkList.forEach(item => {
						this.$refs.multipleTable.toggleRowSelection(item, true)
					})
				})
			},
			dialogFormProductVisible() {
				this.getGoodsAdminList();
				this.visible = true;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleSizeChange(page) {
				this.pageSizes = page;
			},
			handleCurrentChange(page) {
				this.currentPages = page;
				this.getGoodsAdminList();
			},
			submit() {
				this.$emit('confirm', this.multipleSelection)
				this.visible = false
			}
		},
		created() {
			
		}
	}
</script>

<style>
</style>
